(function() { window.GUID_3846f325_53b3_4f36_a87c_b8f32baa86c1 = { getGuid: function() { return "3846f325-53b3-4f36-a87c-b8f32baa86c1"; } }; })();
////Use chartJs and MomentJs
////Can add mobile zoom with this plugin -> https://github.com/chartjs/chartjs-plugin-zoom
//namespace CS.Controls {
//    export class Graph extends ControlBase {
//        public OnBindEvents( ) {
//            this.dataSetRange.ValueChangedCallback = (valueName) => {
//                var e: Graph.IDataSetDateRangeChangedArg = {
//                    maxValue: this.DataSetRange.maxValue,
//                    minValue: this.DataSetRange.minValue,
//                    ChangeType: valueName
//                };
//                this.Trigger<Graph.IDataSetDateRangeChangedArg>(Graph.EventNames.DataSetDateRangeChanged, { jqueryEventObject: null, data: e });
//            };
//        }
//        public OnDispose() {
//            this.dataSetRange.ValueChangedCallback = null; 
//            window.removeEventListener("beforeprint", (event) => { this.beforePrintHandler(); });
//            if (this.chart)
//                this.chart.destroy();
//            if (this.customPreProcessors)
//                for (var namePre in this.customPreProcessors) {
//                    delete this.customPreProcessors[namePre];
//                }
//            if (this.customProcessors)
//                for (var name in this.customProcessors) {
//                    delete this.customPreProcessors[name];
//                }
//            this.$Control.remove();
//        }
//        //use 'ValueBaseControl<Graph>' if it's a value based control
//        private $control: JQuery;
//        private canvas: HTMLCanvasElement;
//        private chart: Chart;
//        private static printHandlerAdded: boolean = false;
//        private customPreProcessors: IDictionary<Graph.ICSGraphCustomProcessor>;
//        private customProcessors: IDictionary<Graph.ICSGraphCustomProcessor>;
//        private dateRangeFilter: DataRange.ReadOnlyDataRangePropertyHelper<Date>;
//        public get DateRangeFilter(): DataRange.ReadOnlyDataRange<Date> {
//            return this.dateRangeFilter.DataRangeReadOnly;
//        }
//        private dataSetRange: DataRange.ReadOnlyDataRangePropertyHelper<Date>;
//        public get DataSetRange(): DataRange.ReadOnlyDataRange<Date> {
//            return this.dataSetRange.DataRangeReadOnly;
//        }
//        protected OnControlInstantiation(params: any[]) {
//            this.dateRangeFilter = new DataRange.ReadOnlyDataRangePropertyHelper<Date>();
//            this.dataSetRange = new DataRange.ReadOnlyDataRangePropertyHelper<Date>();
//            Chart.defaults.global.plugins.datalabels.display = false;
//            this.$control = $(params[0]);//contient le Id
//            //this.Lag("int", 25, () => {
//            this.canvas = <HTMLCanvasElement>document.getElementById(this.ControlId + '_canvas');
//            this.customProcessors = DictHelper.New();
//            this.customPreProcessors = DictHelper.New();
//            this.addDefaultProcessors();
//            this.prepareContent();
//            //});
//        }
//        public get Canvas(): HTMLCanvasElement { return this.canvas; }
//        public get ControlId(): string {
//            return this.$control.attr('id');
//        }
//        public get $Control(): JQuery {
//            return this.$control;
//        }
//        public get ChartJs(): Chart {
//            return this.chart;
//        }
//        public SetDateRangeFilter(minValue?: Date, maxValue?: Date) {
//            this.dateRangeFilter.maxValue = maxValue;
//            this.dateRangeFilter.minValue = minValue;
//            let ch = this.ChartJs;
//            if (!ch.options.scales.xAxes[0].time)
//                ch.options.scales.xAxes[0].time = {};
//            if (minValue)
//                ch.options.scales.xAxes[0].time.min = <any>moment(minValue);
//            else
//                ch.options.scales.xAxes[0].time.min = null;
//            if (maxValue)
//                ch.options.scales.xAxes[0].time.max = <any>moment(maxValue);
//            else
//                ch.options.scales.xAxes[0].time.max = null;
//            ch.update();
//        }
//        public Stacked(isStacked: boolean) {
//            this.chart.options.scales.yAxes[0].stacked = isStacked;
//            this.chart.options.scales.xAxes[0].stacked = isStacked;
//            this.chart.update();
//        }
//        /**
//         * Add a custom processor that will be triger before others if a property with his name is present in a dataset processor -> dataset.processors.name = params. This happen just before the data is loaded into the ChartJs Library.
//         * @param name
//         * the name of the processor
//         * @param processor
//         * the processor callback: (option, dataset, param)
//         * option is the global option, dataset is the dataset where the object was, param is the param object inside the processor
//         */
//        public AddCustomPreProcessor(name: string, processor: Graph.ICSGraphCustomProcessor) {
//            this.customPreProcessors[name] = processor;
//        }
//        /**
//         * Add a custom processor that will be triger if a property with his name is present in a dataset processor -> dataset.processors.name = params. This happen just before the data is loaded into the ChartJs Library.
//         * @param name
//         * the name of the processor
//         * @param processor
//         * the processor callback: (option, dataset, param)
//         * option is the global option, dataset is the dataset where the object was, param is the param object inside the processor
//         */
//        public AddCustomProcessor(name: string, processor: Graph.ICSGraphCustomProcessor) {
//            this.customProcessors[name] = processor;
//        }
//        public FeedUrl(url: string) {
//            let me = this;
//            CS.Ajax.Get(url, null, (response: Graph.IGraphFeed) => {
//                me.SetData(response);
//            });
//        }
//        /** Return an image of the graph. Make sure the annimation is completed before calling this method. Register to Events.AnimationCompleted to get notified when the annimation is completed. */
//        public GetBase64Image(): string {
//            return this.ChartJs.toBase64Image();
//        }
//        public FeedUrlPost(url: string, postData: any) {
//            let me = this;
//            CS.Ajax.Post(url, postData, (response: Graph.IGraphFeed) => {
//                me.SetData(response);
//            });
//        }
//        public SetData(data: Graph.IGraphFeed | CS.Controls.Graph.IGraphResponse) {
//            let me = this;
//            //if (data["RewriteUrl"])
//            //    Navigation.PushState(data["RewriteUrl"]);
//            me.setFunctionOptions(<Graph.IGraphFeed>data);
//            if (me.chart == null) {
//                me.chart = new Chart(me.canvas, data);
//            }
//            else {
//                //Reset if types are different
//                var mustReset = me.chart.config.type != data.type;
//                //reset if a processor or an option tell to reset
//                mustReset = mustReset || me.chart.options["mustReset"] == true || data.options["mustReset"] == true;
//                if (mustReset) {
//                    me.chart.destroy();
//                    me.chart = new Chart(me.canvas, data);
//                }
//                else {
//                    //Here we can't just replace the options, it will not work. Maybe it keep some params inside to track changes ....
//                    me.chart.config.options = $.extend(me.chart.config.options, data.options);
//                    me.chart.data = data.data;
//                    me.chart.update();
//                }
//            }
//        }
//        /**
//        * 
//        * @param id
//        * graph-{controlId}
//        */
//        public static GetById(id: string): Graph {
//            let element = $("#" + id.toLowerCase());
//            let instance = Controls.GetInstance(Controls.Graph, element);
//            return instance;
//        }
//        private addDefaultProcessors() {
//            var preProcessKeys = DictHelper.Keys(CS.Controls.Graph.PreProcessors);
//            if (preProcessKeys.length > 0) {
//                for (var pi = 0; pi < preProcessKeys.length; pi++) {
//                    var processor = CS.Controls.Graph.PreProcessors[preProcessKeys[pi]];
//                    var preProcessCallback = processor.Setup();
//                    this.AddCustomPreProcessor(preProcessKeys[pi], preProcessCallback);
//                }
//            }
//            var keys = DictHelper.Keys(CS.Controls.Graph.Processors);
//            if (keys.length > 0) {
//                for (var i = 0; i < keys.length; i++) {
//                    var graphProcessor = CS.Controls.Graph.Processors[keys[i]];
//                    var callback = graphProcessor.Setup();
//                    this.AddCustomProcessor(keys[i], callback);
//                }
//            }
//        }
//        private prepareContent() {
//            var param = <Graph.Models.ResponseModel.ControlModel>this.$Control.data('model');
//            if (param) {
//                if (param.GraphObject)
//                    this.SetData(param.GraphObject);
//                else if (param.FeedUrl)
//                    this.FeedUrl(param.FeedUrl);
//            }
//            if (!Graph.printHandlerAdded) {
//                Graph.printHandlerAdded = true;
//                //Not supported in safari -> https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onbeforeprint
//                window.addEventListener("beforeprint", (event) => { this.beforePrintHandler(); });
//            }
//        }
//        private beforePrintHandler() {
//            this.chart.resize();
//        }
//        //this is called just before data are passed to the chartJs control.
//        private setFunctionOptions(response: Graph.IGraphFeed) {
//            var me = this;
//            if (!response.options)
//                response.options = {};
//            if (!response.options.plugins)
//                response.options.plugins = {};
//            if (!response.options.plugins["datalabels"])
//                response.options.plugins["datalabels"] = {};
//            var datalabels = response.options.plugins["datalabels"];
//            var defOptions = Chart.defaults.global.plugins.datalabels; //default global options for datalabels plugin
//            if (!datalabels.backgroundColor)
//                datalabels.backgroundColor = function (context) {
//                    return context.dataset.datalabels.backgroundColor || defOptions.backgroundColor;
//                };
//            if (!datalabels.borderRadius)
//                datalabels.borderRadius = function (context) {
//                    return context.dataset.datalabels.borderRadius || defOptions.borderRadius;
//                };
//            if (!datalabels.font)
//                datalabels.font = function (context) {
//                    return context.dataset.datalabels.font || defOptions.font;
//                };
//            if (!response.options.animation)
//                response.options.animation = {};
//            this.checkDataSetDateRange(response);
//            //if (!datalabels.formatter)
//            //    datalabels.formatter = function (value, context) {
//            //        var value = context.dataset.data[context.dataIndex];
//            //        var label = context.chart.data.labels[context.dataIndex];
//            //        var dataLabel = me.originalData.datasets[context.datasetIndex].data[context.dataIndex];
//            //        if (dataLabel["label"])
//            //            label = dataLabel["label"];
//            //        return context.chart.data.labels[context.dataIndex];
//            //    }
//            //Processors are loaded here. if a property with the name of the processor exist in the dataset, 
//            //the processor is loaded and the object inside the property is passed to the processor as a param
//            var preProcessorsKeys = DictHelper.Keys(me.customPreProcessors);
//            var processorsKeys = DictHelper.Keys(me.customProcessors);
//            var key = "";
//            var keys = new Array<string>();
//            var processors = <IDictionary<any>>{};
//            if ((processorsKeys.length > 0 || preProcessorsKeys.length > 0) && response.data != null && response.data.datasets != null && response.data.datasets.length > 0) {
//                for (var i = 0; i < response.data.datasets.length; i++) {
//                    var dataset = response.data.datasets[i];
//                    if ((<any>dataset).processors != null) {
//                        processors = <IDictionary<any>>(<any>dataset).processors;
//                        keys = DictHelper.Keys(processors);
//                        for (var pk = 0; pk < keys.length; pk++) {
//                            key = keys[pk];
//                            if (preProcessorsKeys.indexOf(key) > -1) {
//                                me.customPreProcessors[key](me, response, dataset, processors[key]);
//                            }
//                        }
//                        for (var k = 0; k < keys.length; k++) {
//                            key = keys[k];
//                            if (processorsKeys.indexOf(key) > -1) {
//                                me.customProcessors[key](me, response, dataset, processors[key]);
//                            }
//                        }
//                    }
//                }
//            }
//            if (response.options.animation.onComplete) {
//                var original = response.options.animation.onComplete;
//                response.options.animation.onComplete = (chart) => {
//                    original(chart);
//                    this.raiseAnimationCompleted();
//                };
//            }
//            else
//                response.options.animation.onComplete = () => { this.raiseAnimationCompleted(); };
//        }
//        private checkDataSetDateRange(response: that.IGraphFeed) {
//            if (response.CustomData && response.CustomData.DateRangeInfo) {
//                let dateRange = response.CustomData.DateRangeInfo;
//                let newDataSetRange: CS.DataRange.IDataRange<Date> = { maxValue: null, minValue: null };
//                if (dateRange.MaxDate)
//                    newDataSetRange.maxValue = Helper.MomentJs.ConvertMomentToJsDate(moment(dateRange.MaxDate));
//                if (dateRange.MinDate)
//                    newDataSetRange.minValue = Helper.MomentJs.ConvertMomentToJsDate(moment(dateRange.MinDate));
//                let changed = false;
//                if (newDataSetRange.maxValue && newDataSetRange.minValue) {
//                    if (this.dataSetRange.maxValue && this.dataSetRange.minValue) {
//                        if (this.dataSetRange.maxValue.getTime() != newDataSetRange.maxValue.getTime())
//                            changed = true;
//                        if (this.dataSetRange.minValue.getTime() != newDataSetRange.minValue.getTime())
//                            changed = true;
//                    }
//                    else
//                        changed = true;
//                }
//                if (changed)
//                    this.dataSetRange.SetData(newDataSetRange);
//            }
//        }
//        private raiseAnimationCompleted() {
//            this.Trigger<that.IGraphEventBase>(that.EventNames.AnimationCompleted, { jqueryEventObject: null, data: {} });
//        }
//    }
//    export namespace Graph {
//        /*
//        *dataset.processors.name = param
//        * */
//        /** (feed: IGraphFeed, dataset: Chart.ChartDataSets, param?: any) */
//        export interface ICSGraphCustomProcessor {
//            /** dataset is the dataset where the object was, param is the param object inside the processor*/
//            (control: Graph, feed: IGraphFeed, dataset: Chart.ChartDataSets, param?: any): void;
//        }
//        export abstract class GraphProcessor {
//            static Setup(): Graph.ICSGraphCustomProcessor { throw new Error("Method not implemented."); }
//        }
//        export interface IGraphFeed extends CS.Controls.Graph.Models.ResponseModel.ICustomDataContainer {
//            type: string;
//            data: Chart.ChartData;
//            options: Chart.ChartOptions;
//        }
//        export class Events {
//            public static AnimationCompleted(param: IEvent<Graph, IGraphEventBase>) {
//                RegisterEvent(Graph, EventNames.AnimationCompleted, param);
//            }
//            public static DataSetDateRangeChanged(param: IEvent<Graph, IDataSetDateRangeChangedArg>) {
//                RegisterEvent(Graph, EventNames.DataSetDateRangeChanged, param);
//            }
//        }
//        export class EventNames {
//            public static AnimationCompleted = "graph-animation-complete";
//            public static DataSetDateRangeChanged = "graph-dataset-daterange-changed";
//        }
//        export interface IGraphEventBase {
//        }
//        export interface IDataSetDateRangeChangedArg extends IGraphEventBase, DataRange.IDataRange<Date> {
//            ChangeType: DataRange.ValueChangedType<Date>;
//        }
//    }
//    import that = CS.Controls.Graph;
//}
//namespace CS.Controls.Graph {
//}
//namespace CS.Controls.Graph.PreProcessors {
//    export class DataLabelFix extends GraphProcessor {
//        //This processor fix unsuported DataLabel with DataWrapper
//        static Setup(): Graph.ICSGraphCustomProcessor {
//            return (control: Graph, feed: IGraphFeed, dataset: Chart.ChartDataSets, param?: Models.Processors.DataLabelFix) => {
//                var DataWrappers = DictHelper.New<Models.ResponseModel.DataWrapper>();
//                if (dataset.data != null && dataset.data.length > 0)
//                    for (var i = 0; i < dataset.data.length; i++) {
//                        if (dataset.data[i]["label"]) {
//                            DataWrappers[i] = <Models.ResponseModel.DataWrapper>dataset.data[i];
//                            if (DataWrappers[i].y != null)
//                                dataset.data[i] = DataWrappers[i].y;
//                        }
//                    }
//                var keys = DictHelper.Keys(DataWrappers);
//                if (keys.length > 0) {
//                    if (dataset["datalabels"] == null)
//                        dataset["datalabels"] = {};
//                    dataset["datalabels"].DataLabelFix = function (value, context) {
//                        if (keys.indexOf(context.dataIndex + "") > -1) {
//                            var wrapper = DataWrappers[context.dataIndex];
//                            return wrapper.label;
//                        }
//                        return null;
//                    };
//                    var existing = null;
//                    var allredySet = false;
//                    if (feed.options.plugins != null && feed.options.plugins["datalabels"] != null) {
//                        existing = feed.options.plugins["datalabels"].formatter;
//                        if (existing && feed.options.plugins["datalabels"].DataLabelFix)
//                            allredySet = true;
//                        else
//                            feed.options.plugins["datalabels"].DataLabelFix = true;
//                    }
//                    if (feed.options.plugins == null)
//                        feed.options.plugins = {};
//                    if (feed.options.plugins["datalabels"] == null)
//                        feed.options.plugins["datalabels"] = {};
//                    if (!allredySet)
//                        feed.options.plugins["datalabels"].formatter = function (value, context) {
//                            //var value = context.dataset.data[context.dataIndex];
//                            //var label = context.chart.data.labels[context.dataIndex];
//                            //var dataLabel = me.originalData.datasets[context.datasetIndex].data[context.dataIndex];
//                            //if (dataLabel["label"])
//                            //    label = dataLabel["label"];
//                            //return context.chart.data.labels[context.dataIndex];
//                            if (context.dataset["datalabels"] != null && context.dataset["datalabels"].DataLabelFix) {
//                                var resultlbl = context.dataset["datalabels"].DataLabelFix(value, context);
//                                if (resultlbl != null)
//                                    return resultlbl;
//                            }
//                            if (existing != null) {
//                                var result = existing(value, context);
//                                if (result != null)
//                                    return result;
//                            }
//                            if (value.label)
//                                return value.label;
//                            return value;
//                        };
//                }
//            };
//        }
//    }
//    //export class EnableXserie extends GraphProcessor {
//    //    //This processor fix unsuported DataLabel with DataWrapper
//    //    static Setup(): Graph.ICSGraphCustomProcessor {
//    //        return (control: Graph, feed: IGraphFeed, dataset: Chart.ChartDataSets, param?: Models.Processors.EnableXserie) => {
//    //            for (var i = 0; i < feed.options.scales.xAxes.length; i++) {
//    //                var axe = feed.options.scales.xAxes[i];
//    //                if (axe.id == param.XAxeId && !axe["EnableXserie"]) {
//    //                    axe["EnableXserie"] = true;
//    //                    if (!axe.ticks)
//    //                        axe.ticks = {};
//    //                    axe.ticks.callback = this.ticksCallback;
//    //                }
//    //            }
//    //        };
//    //    }
//    //    private static ticksCallback(value: any, index: any, values: any): string | number {
//    //        return null;
//    //    }
//    //}
//}
//namespace CS.Controls.Graph.Processors {
//    export class ProcessorName extends GraphProcessor {
//        static Setup(): Graph.ICSGraphCustomProcessor {
//            return (control: Graph, feed: IGraphFeed, dataset: Chart.ChartDataSets, param?: any) => {
//            };
//        }
//    }
//    export class TooltipFormat extends GraphProcessor {
//        static Setup(): Graph.ICSGraphCustomProcessor {
//            return (control: Graph, feed: IGraphFeed, dataset: Chart.ChartDataSets, param?: Graph.Models.Processors.TooltipFormat) => {
//                var datasetIndex = feed.data.datasets.indexOf(dataset);
//                if (feed.options == null)
//                    feed.options = {};
//                if (feed.options.tooltips == null)
//                    feed.options.tooltips = {};
//                if (feed.options.tooltips.callbacks == null)
//                    feed.options.tooltips.callbacks = {};
//                if (control["ToolTipsProcessor"] == null)
//                    control["ToolTipsProcessor"] = DictHelper.New<Graph.Models.Processors.TooltipFormat>();
//                var toolTipsProcessor = <IDictionary<Graph.Models.Processors.TooltipFormat>>control["ToolTipsProcessor"];
//                toolTipsProcessor[datasetIndex + ''] = param;
//                feed.options.tooltips.callbacks.label = (tooltipItem: Chart.ChartTooltipItem, data: Chart.ChartData) => {
//                    var label = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] || '';
//                    if (DictHelper.ContainsKey(toolTipsProcessor, tooltipItem.datasetIndex + "")) {
//                        var param = toolTipsProcessor[tooltipItem.datasetIndex + ""];
//                        if (param != null) {
//                            if (param.prepend)
//                                label = param.prepend + label;
//                            if (param.append)
//                                label += param.append;
//                        }
//                    }
//                    return label + "";
//                };
//            };
//        }
//    }
//    export class DataLabelShowName extends GraphProcessor {
//        static Setup(): Graph.ICSGraphCustomProcessor {
//            return (control: Graph, feed: IGraphFeed, dataset: Chart.ChartDataSets, param?: Graph.Models.Processors.DataLabelFix) => {
//                if (dataset["datalabels"] != null && dataset["datalabels"].labels != null && dataset["datalabels"].labels.name != null)
//                    dataset["datalabels"].labels.name.formatter = function (value, ctx) {
//                        return ctx.chart.data.labels[ctx.dataIndex];
//                    };
//            };
//        }
//    }
//    //export class ProcessorName extends GraphProcessor {
//    //    static Setup(): Graph.ICSGraphCustomProcessor {
//    //        return (feed: IGraphFeed, dataset: Chart.ChartDataSets, param?: Models.Processors.DataLabelFix) => {
//    //            var dataLabel = {
//    //                labels: {
//    //                    //index: {
//    //                    //    align: 'end',
//    //                    //    anchor: 'end',
//    //                    //    color: function (ctx) {
//    //                    //        return ctx.dataset.backgroundColor;
//    //                    //    },
//    //                    //    font: { size: 18 },
//    //                    //    formatter: function (value, ctx) {
//    //                    //        return ctx.active
//    //                    //            ? 'index'
//    //                    //            : '#' + (ctx.dataIndex + 1);
//    //                    //    },
//    //                    //    offset: 8,
//    //                    //    opacity: function (ctx) {
//    //                    //        return ctx.active ? 1 : 0.5;
//    //                    //    }
//    //                    //},
//    //                    name: {
//    //                        align: 'top',
//    //                        font: { size: 16 },
//    //                        backgroundColor: function (ctx) {
//    //                            if (Array.isArray(ctx.dataset.backgroundColor))
//    //                                return ctx.dataset.backgroundColor[ctx.dataIndex];
//    //                            return ctx.dataset.backgroundColor;
//    //                        },
//    //                        formatter: function (value, ctx) {
//    //                            return ctx.active
//    //                                ? 'name'
//    //                                : ctx.chart.data.labels[ctx.dataIndex];
//    //                        }
//    //                    },
//    //                    value: {
//    //                        align: 'bottom',
//    //                        backgroundColor: function (ctx) {
//    //                            var value = ctx.dataset.data[ctx.dataIndex];
//    //                            return value > 12 ? 'white' : null;
//    //                        },
//    //                        borderColor: 'white',
//    //                        borderWidth: 2,
//    //                        borderRadius: 4,
//    //                        color: function (ctx) {
//    //                            var value = ctx.dataset.data[ctx.dataIndex];
//    //                            return value > 12
//    //                                ? ctx.dataset.backgroundColor
//    //                                : 'white';
//    //                        },
//    //                        formatter: function (value, ctx) {
//    //                            return ctx.active
//    //                                ? 'value ' + param.valueAddon
//    //                                : Math.round(value * 1000) / 1000;
//    //                        },
//    //                        padding: 4
//    //                    }
//    //                }
//    //            }
//    //            //var dataLayoutOption = {
//    //            //    layout: {
//    //            //        padding: {
//    //            //            top: 70
//    //            //        }
//    //            //    }
//    //            //}
//    //            var plugin = <Chart.PluginServiceRegistrationOptions & Chart.PluginServiceGlobalRegistration>{
//    //                //This is a plugin homeMade to add 50px between the legend and chart
//    //                beforeInit: function (chart, options) {
//    //                    (<any>chart).legend.afterFit = function () {
//    //                        this.height = this.height + 50;
//    //                    };
//    //                }
//    //            };
//    //            if ((<any>dataset).datalabels != null)
//    //                (<any>dataset).datalabels = $.extend((<any>dataset).datalabels, dataLabel);
//    //            else
//    //                (<any>dataset).datalabels = dataLabel;
//    //            //if (options.layout != null)
//    //            //    options.layout = $.extend(options.layout, dataLayoutOption.layout);
//    //            //else
//    //            //    options.layout = dataLayoutOption.layout;
//    //            if (feed["plugins"] == null)
//    //                feed["plugins"] = {};
//    //            //this will reset the control on next update
//    //            feed.options["mustReset"] = true;
//    //            feed["plugins"]["beforeInit"] = plugin.beforeInit;
//    //        };
//    //    }
//    //}
//}

//# sourceMappingURL=CSGraph.js.map
